import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { CustomButtonsModule } from '@shared/buttons';
import { BaseToolComponent } from './base-tool/base-tool.component';
import { BrushToolComponent } from './brush-tool/brush-tool.component';
import { EraserToolComponent } from './eraser-tool/eraser-tool.component';
import { LassoToolComponent } from './lasso-tool/lasso-tool.component';
import { ViewChangesToolComponent } from './view-changes-tool/view-changes-tool.component';
import { ToolListComponent } from './tool-list/tool-list.component';
import { PointerSettingsComponent } from './pointer-settings/pointer-settings.component';
import { UndoRedoComponent } from './undo-redo/undo-redo.component';
import { BrightnessToolComponent } from './brightness-tool/brightness-tool.component';
import { ResetTransparencyComponent } from './reset-transparency/reset-transparency.component';
import { ResetChangesToolComponent } from './reset-changes-tool/reset-changes-tool.component';
import { ToolListService } from './tool-list/tool-list.service';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatSliderModule,
    MatSelectModule,
    MatTooltipModule,
    TranslateModule,
    CustomButtonsModule,
  ],
  declarations: [
    BaseToolComponent,
    BrushToolComponent,
    EraserToolComponent,
    LassoToolComponent,
    ViewChangesToolComponent,
    ToolListComponent,
    PointerSettingsComponent,
    BrightnessToolComponent,
    UndoRedoComponent,
    ResetTransparencyComponent,
    ResetChangesToolComponent,
  ],
  exports: [
    ToolListComponent,
    BrushToolComponent,
    EraserToolComponent,
    LassoToolComponent,
  ],
  providers: [ToolListService],
})
export class EditImageToolsModule {}
